import { boolean, integer, pgTable, text, timestamp, unique, uuid } from 'drizzle-orm/pg-core';

import { departments } from './departments';
import { organizations } from './organizations';
import { tenantOrgIsolationPolicy } from './rls';
import { tenants } from './tenants';

export const workflowStages = pgTable(
  'workflow_stages',
  {
    id: uuid('id').primaryKey().defaultRandom(),
    tenantId: uuid('tenant_id')
      .notNull()
      .references(() => tenants.id),
    orgId: uuid('org_id')
      .notNull()
      .references(() => organizations.id),
    departmentId: uuid('department_id')
      .notNull()
      .references(() => departments.id),
    name: text('name').notNull(),
    slug: text('slug').notNull(),
    position: integer('position').notNull(),
    color: text('color'),
    isSystem: boolean('is_system').notNull().default(false),
    systemKey: text('system_key'),
    createdAt: timestamp('created_at', { withTimezone: true }).notNull().defaultNow(),
    updatedAt: timestamp('updated_at', { withTimezone: true })
      .notNull()
      .defaultNow()
      .$onUpdateFn(() => new Date())
  },
  (t) => [
    unique('workflow_stages_dept_slug').on(t.tenantId, t.orgId, t.departmentId, t.slug),
    tenantOrgIsolationPolicy()
  ]
).enableRLS();
